import { get } from "lib/fetch";

export const GET_TEMPLATES = "templates/GET";
export const GET_TEMPLATE = "template/GET";

export const getTemplates = () => ({
  type: GET_TEMPLATES,
  payload: get("/v1/templates"),
});

export const getTemplate = (id?: number | null) => ({
  type: GET_TEMPLATE,
  payload: get(`/v1/template/${id}`),
});
